export const missingProfileDetails = (user: User) => {
  return (
    !user.email ||
    !user.firstName ||
    !user.lastName ||
    !user.licenseNumber ||
    !user.phone
  )
}
